/**
 * Layout: Opleidingen overzicht
 * Slug: opleidingen_overview
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.opleidingen_overview-layout');

	layouts.forEach((layout) => {
		
	});
});
